// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".connected-account-container[data-v-4ad6cf5c]{display:flex;justify-content:space-between;align-items:center;width:100%;padding:10px;grid-gap:10px;gap:10px;margin-bottom:12px;flex-wrap:wrap;background-color:#1e1e1e;border-radius:10px}.steam-logo-container[data-v-4ad6cf5c]{background:#313131;display:flex;justify-content:center;align-items:center;padding:7px;border-radius:50px;width:50px;height:50px}.steam-logo-container img[data-v-4ad6cf5c]{width:30px;height:30px}", ""]);
// Exports
module.exports = exports;
